import { Routes, Route} from "react-router-dom"
import AddQuejaComponent from '../components/modulos/Registro';
import LoginUser from '../components/users/LoginUser';
import SeguimientoQueja from "../components/modulos/seguimiento";
import DetailPostQueja from "../components/modulos/DetailPostQueja";
import Index from "../components/modulos/Index";


export const PublicAppRouter = () => {
    return (
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/registro" element={<AddQuejaComponent />} />
        <Route path="/seguimiento" element={<SeguimientoQueja />} />
        <Route path="/resumen-queja/:id" element={<DetailPostQueja />} />
        <Route path="api/**"/>
        <Route path="/login" element={<LoginUser />} />
        <Route path="*" element={<Index />}/>
      </Routes> 
    )
  }